import { Button, Icon } from '@loanpal/lumos__core';
import { styles } from "./styles";

export const ResetButton = ({ onClick, children }) => (
  <Button
    onClick={onClick}
    variant="ghost"
    sx={{ color: '#00838f', textTransform: 'capitalize', fontSize: 2 }}
  >
    <div style={styles.resetButtonIcon}>
      <Icon variant="undo" color="white" />
    </div>
    {children}
  </Button>
);

export const ResetBar = ({ onClick, children }) => (
  <div style={styles.backBar}>
    <ResetButton onClick={onClick}>{children}</ResetButton>
  </div>
);